/**************************************************
 * Nombre:       Formulario_Deposito_Ver
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {CalendarMonthOutlined, FlagOutlined, MoneyOutlined,AccountBalanceOutlined,Numbers} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import {useEffect, useState} from "react";

const Formulario_Deposito_Ver = ({...props}) => {
    const [datos, setDatos] = useState({});

    useEffect(() => {

        let ent = props.props.getValues()
        setDatos(ent)

    }, [props.props.watch]);

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={Numbers} nombre={'Numero'} dato={'consecutivo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                        editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos de Transaccion</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={CalendarMonthOutlined} nombre={'Ahorro del Mes:'} dato={'mes'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo'} dato={'tipoTransaccion'} {...props}
                                   opciones={['Transaccion', 'En Efectivo']} editable={false}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Monto'} dato={'valor'} {...props}
                        editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <Zoom>
                        <img

                            src={datos.img}
                            width="100%"
                        />
                    </Zoom>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos de Validacion</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountBalanceOutlined} nombre={'Numero de transaccion'}
                                  dato={'numTransaccion'} {...props} editable={false}
                    />
                </Grid>



            </Grid>
        </form>

    )

}
export default Formulario_Deposito_Ver